import { arbitragesSchema } from "../schemas/index.js";
/**
 * `GET /flow/v1/arbitrages` — cross-venue risk-free opportunities (needs `arbitrage:read`).
 * Each arb's `combined_price` < 1 means buying every side guarantees $1 for that cost.
 * Real-time updates come from the `arbitrage` WS channel (`arbitrage.update`).
 */
export class ArbitragesResource {
    http;
    constructor(http) {
        this.http = http;
    }
    list(params = {}) {
        return this.http.request({
            method: "GET",
            path: "/arbitrages",
            endpoint: "arbitrages.list",
            query: {
                contest_id: params.contest_id,
                league_id: params.league_id,
                market_id: params.market_id,
                partner_id: params.partner_id,
                min_roi: params.min_roi,
                after_fee: params.after_fee,
                min_after_fee_roi: params.min_after_fee_roi,
                min_investment: params.min_investment,
                sort: params.sort,
                limit: params.limit,
            },
            dataSchema: arbitragesSchema,
        });
    }
}
//# sourceMappingURL=arbitrages.js.map